export const AdsMinimalFooter = () => (
  <footer className="py-6 bg-foreground text-background/60 text-center text-xs">
    <div className="container mx-auto px-4">
      <p>© {new Date().getFullYear()} Safeway Roofing & Siding. All rights reserved. Licensed & Insured.</p>
    </div>
  </footer>
);
